// extracted by mini-css-extract-plugin
export default {"columns":"StudentChatsTab_columns__n1WcS","chats-header":"StudentChatsTab_chats-header__78w6h"};